import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import Loading from '../../components/Loading';

const AccountMainPageComponent = lazy(
  () => import(/* webpackChunkName: "account" */ '../../pages/account'),
);

const AccountOverviewComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/AccountOverview'
    ),
);

const EditInformationComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/EditInformation'
    ),
);

const MyDevicesComponent = lazy(
  () =>
    import(/* webpackChunkName: "account" */ '../../pages/account/my-devices'),
);

// Transfer device is deprecated
// const AddDeviceToTransferComponent = lazy(
//   () =>
//     import(
//       /* webpackChunkName: "account" */ '../../pages/common/account/my-devices/transfer-devices/AddDeviceToTransfer'
//     ),
// );

const AddMemberComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/my-devices/AddMember'
    ),
);

const ConfimMemberComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/my-devices/ConfimMember'
    ),
);

const NotificationListComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/notification-list'
    ),
);

const LanguageSettingPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/language-setting'
    ),
);

const ChangePasswordPageComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/ChangePassword'
    ),
);

const MultiFactorAuthentication = lazy(
  () =>
    import(
      /* webpackChunkName: "account" */ '../../pages/account/MultiFactorAuthentication'
    ),
);

const accountRouter = () => (
  <Route
    path={'account'}
    element={
      <Suspense fallback={<Loading />}>
        <AccountMainPageComponent />
      </Suspense>
    }
  >
    <Route
      path=""
      element={
        <Suspense fallback={<Loading />}>
          <AccountOverviewComponent />
        </Suspense>
      }
    />
    <Route
      path="edit-information"
      element={
        <Suspense fallback={<Loading />}>
          <EditInformationComponent />
        </Suspense>
      }
    />
    <Route
      path="my-devices"
      element={
        <Suspense fallback={<Loading />}>
          <MyDevicesComponent />
        </Suspense>
      }
    >
      <Route
        path="assign"
        element={
          <Suspense fallback={<Loading />}>
            <AddMemberComponent />
          </Suspense>
        }
      >
        <Route
          path="confirm"
          element={
            <Suspense fallback={<Loading />}>
              <ConfimMemberComponent />
            </Suspense>
          }
        />
      </Route>
      {/* <Route path="transfer" element={<AddDeviceToTransferComponent />} /> */}
    </Route>
    <Route
      path="project/:projectId/notification-list"
      element={
        <Suspense fallback={<Loading />}>
          <NotificationListComponent />
        </Suspense>
      }
    />
    <Route
      path="notification-list"
      element={
        <Suspense fallback={<Loading />}>
          <NotificationListComponent />
        </Suspense>
      }
    />
    <Route
      path="language-setting"
      element={
        <Suspense fallback={<Loading />}>
          <LanguageSettingPageComponent />
        </Suspense>
      }
    />
    <Route
      path="change-password"
      element={
        <Suspense fallback={<Loading />}>
          <ChangePasswordPageComponent />
        </Suspense>
      }
    />
    <Route
      path="two-factor-authentication"
      element={
        <Suspense fallback={<Loading />}>
          <MultiFactorAuthentication />
        </Suspense>
      }
    />
  </Route>
);

export default accountRouter;
